import { render } from "./PricesView.vue?vue&type=template&id=32d6f150"
import script from "./PricesView.vue?vue&type=script&lang=js"
export * from "./PricesView.vue?vue&type=script&lang=js"

import "./PricesView.vue?vue&type=style&index=0&id=32d6f150&lang=scss"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__